import React, { Component } from "react";
import { connect } from "react-redux";
import MobileMenu2 from "../MobileMenu2";
import { removeFromCart } from "../../store/actions/action";
import { Link } from "react-scroll";
import { NavLink, useLocation } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";

class Header2Inner extends Component {
  render() {
    const { isHome, t, language, changeLanguage } = this.props;

    const navItems = [
      { key: "home",     label: t("nav.home"),     offset: 0 },
      { key: "couple",   label: t("nav.couple"),   offset: -100 },
      { key: "location", label: t("nav.location"), offset: -80 },
      { key: "events",   label: t("nav.events"),   offset: -80 },
      { key: "RSVP",     label: t("nav.rsvp"),     offset: 0 },
      { key: "gallery",  label: t("nav.gallery"),  offset: -100 },
    ];

    return (
      <header id="home" className={this.props.topbarNone}>
        <div className={`wpo-site-header ${this.props.hclass}`}>
          <nav className="navigation navbar navbar-expand-lg navbar-light">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                  <div className="mobail-menu">
                    <MobileMenu2 />
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-6">
                  <div
                    className="navbar-header"
                    style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                  >
                    <NavLink
                      className="navbar-brand"
                      to="/"
                      style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: "0 auto" }}
                    >
                      <img src={this.props.Logo} alt="" style={{ height: "auto" }} />
                    </NavLink>
                  </div>
                </div>
                <div className="col-lg-6 col-md-1 col-1">
                  <div id="navbar" className="collapse navbar-collapse navigation-holder">
                    <button className="menu-close">
                      <i className="ti-close"></i>
                    </button>
                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                      {navItems.map((item) => (
                        <li key={item.key}>
                          {isHome ? (
                            <Link
                              activeClass="active"
                              to={item.key}
                              spy={true}
                              smooth={true}
                              offset={item.offset}
                              duration={500}
                            >
                              {item.label}
                            </Link>
                          ) : (
                            <a href={`/#${item.key}`}>{item.label}</a>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-2 col-2 d-none d-lg-block">
                  <div className="header-right">
                    <div className="cart-search-contact">
                      <div className="language-selector">
                        <button
                          onClick={() => changeLanguage("hu")}
                          className={`language-btn ${language === "hu" ? "active" : ""}`}
                        >
                          HU
                        </button>
                        <button
                          onClick={() => changeLanguage("en")}
                          className={`language-btn ${language === "en" ? "active" : ""}`}
                        >
                          EN
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state) => ({
  carts: state.cartList.cart,
});

const Header2Connected = connect(mapStateToProps, { removeFromCart })(Header2Inner);

const Header2 = (props) => {
  const { language, changeLanguage, t } = useLanguage();
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <Header2Connected
      {...props}
      language={language}
      changeLanguage={changeLanguage}
      t={t}
      isHome={isHome}
    />
  );
};

export default Header2;
